import createMutator from '../../utils/createMutator';

export const setElements = createMutator('set', 'elements');